import { render, staticRenderFns } from "./VatValidation.vue?vue&type=template&id=67edc03e&scoped=true"
import script from "./VatValidation.vue?vue&type=script&lang=ts"
export * from "./VatValidation.vue?vue&type=script&lang=ts"
import style0 from "./VatValidation.vue?vue&type=style&index=0&id=67edc03e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67edc03e",
  null
  
)

export default component.exports